import { render, staticRenderFns } from "./AddonInformationCard.vue?vue&type=template&id=45649b2e&scoped=true"
import script from "./AddonInformationCard.vue?vue&type=script&lang=js"
export * from "./AddonInformationCard.vue?vue&type=script&lang=js"
import style0 from "./AddonInformationCard.vue?vue&type=style&index=0&id=45649b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45649b2e",
  null
  
)

export default component.exports